<form [formGroup]="formGroup">
  <kendo-grid [data]="documents">
      <kendo-grid-column [title]="'ausschreibung.unterlagen.grid.download' | translate" field="download" [width]="50">
          <ng-template kendoGridHeaderTemplate>
              <label class="labelcheckboxdownload" [for]="'downloadCheckbox'">
                  <input [title]="'ausschreibung.unterlagen.grid.download' | translate" id="downloadCheckbox" type="checkbox" formControlName="toggleAll" (click)="toggleAll()">
              </label>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <label class="labelcheckboxdownload" [for]="'downloadCheckbox' + rowIndex">
                  <input [title]="getCheckBoxName(rowIndex)" id="'downloadCheckbox' + rowIndex" type="checkbox" [formControl]="getFormControlByRowIndexAndName(rowIndex, 'download')">
              </label>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [title]="'ausschreibung.unterlagen.grid.name' | translate" field="name" [width]="200">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                  {{getFileName(dataItem)}}
              </span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [title]="'ausschreibung.unterlagen.grid.filetype' | translate" field="filetype" [width]="50">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                  {{getFileType(dataItem)}}
              </span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [title]="'ausschreibung.unterlagen.grid.filesize' | translate" field="fileSize" [width]="50">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                  {{getFileSize(dataItem)}}
              </span>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</form>

<kendo-dialog-actions>
  <button class="cancel-button" kendoButton (click)="closeDialog(false)" [attr.aria-label]="'ausschreibung.unterlagen.dialog-cancel' | translate">{{'ausschreibung.unterlagen.dialog-cancel' | translate }}</button>
  <button class="confirm-button" kendoButton (click)="closeDialog(true)" [disabled]="isDownloadDisabled" [attr.aria-label]="'ausschreibung.unterlagen.dialog-download' | translate">{{'ausschreibung.unterlagen.dialog-download' | translate }}</button>
</kendo-dialog-actions>